import { Terminal, Database, Server, Smartphone } from 'lucide-react';

/**
 * Global Configuration
 * 
 * Central source of truth for all static content and portfolio data.
 * Includes personal info, stats, services, skills, projects, and experience.
 */
export const CONFIG = {
    personal: {
        name: "Lanya Mohammed",
        title: "Full Stack DOTNET Developer",
        tagline: "Building efficient, secure, and scalable Website and Applications",
        email: "lanyamhamad02@gmail.com",
        phone: "0770 579 7755",
        location: "Sulaymaniyah, Kurdistan",
        github: "https://github.com/Lanyamhamad",
        linkedin: "https://www.linkedin.com/in/lanya-mhamad-34275928a",
        avatar: "/LMDeveloperblack.png",
        cvUrl: "/Lanya_Mohammed_CV.pdf"
    },

    stats: [
        { id: 1, number: "1+", label: "Years Experience" },
        { id: 2, number: "3+", label: "Projects Completed" },
        { id: 3, number: "5+", label: "Technologies" },
        { id: 4, number: "95%", label: "Client Satisfaction" }
    ],

    services: [
        {
            id: 1,
            title: "Backend Development",
            description: "Robust and scalable backend systems using ASP.NET Core & Entity Framework.",
            icon: Server
        },
        {
            id: 2,
            title: "API Development",
            description: "Secure RESTful APIs with proper authentication and authorization standards.",
            icon: Terminal
        },
        {
            id: 3,
            title: "Database Design",
            description: "Optimized database schemas and efficient queries using SQL Server,PostgreSQL.",
            icon: Database
        },
        {
            id: 4,
            title: "Mobile Development",
            description: "Cross-platform mobile applications using Flutter and Dart.",
            icon: Smartphone
        }
    ],

    skills: {
        languages: ["C#", "JavaScript","HTML", "CSS", "Java", "Dart", "Python", "PHP", "SQL"],
        backend: ["ASP.NET Core", "ASP.NET MVC", "ASP.NET Web API", "Minimal APIs", "Entity Framework Core", "RESTful API Development", "Repository Pattern", "Clean Architecture", "Authentication & Authorization", "JWT Authentication"],
        frontend: ["React", "Blazor", "Razor Pages", "Tailwind CSS", "Bootstrap", "JQuery", "Kendo UI", "MudBlazor"],
        databases: ["SQL Server", "Stored Procedures", "Views", "Functions", "CRUD Operations", "Database Design", "Query Optimization", "Entity Framework Core"],
        tools: ["Git & GitHub", "Docker (Basic)", "Railway Deployment", "Postman", "Visual Studio", "Visual Studio Code", "SQL Server Management Studio"],
        ide: ["Visual Studio Code", "Visual Studio", "Postman", "SQL Server Management Studio"],
        other: ["API development", "Windows Form Application", "WPF", "problem-solving", "debugging", "teamwork", "agile mindset"]
    },

    specializations: ["Backend Development", "API Development", "DOTNET Developer"],
    coreskills: ["ASP.NET CORE", "BLAZOR", "SQL server", "ASP.NET MVC", "ENTITY FRAMEWORK", "C#", "FLUTTER"],

    projects: [
        {
            id: 1,
            title: "Inventory Management System",
            description: "Enterprise-grade inventory system for warehouse management. Built with Clean Architecture principles.",
            category: "Web App",
            technologies: ["ASP.NET Core", "Blazor", "SQL Server", "MudBlazor"],
            github: "https://github.com/Lanyamhamad/",
            features: ["JWT Auth", "Real-time Updates", "Reporting"],
            status: "Completed"
        },
        {
            id: 2,
            title: "Social Media Manager",
            description: "Business-focused social media tool for managing workflows and content scheduling.",
            category: "Mobile App",
            technologies: ["Flutter", "Dart", "Laravel", "MySQL"],
            github: "https://github.com/Lanyamhamad/",
            features: ["Responsive UI", "Content Scheduling", "Analytics"],
            status: "Completed"
        },
        {
            id: 3,
            title: "Ekhadamaty ERP",
            description: "Large-scale enterprise service application for managing business resources and services.",
            category: "Enterprise",
            technologies: ["ASP.NET MVC", "SQL Server", "Kendo UI"],
            github: "https://github.com/Lanyamhamad/",
            features: ["Role-based Access", "Complex Reporting", "Legacy Integration"],
            status: "Completed"
        },
        {
            id: 4,
            title: "FinShark",
            description: "Financial data management system with stock portfolio tracking.",
            category: "Web App",
            technologies: ["ASP.NET Core", "React", "SQL Server"],
            github: "https://github.com/Lanyamhamad/FinShark",
            features: ["Stock Tracking", "Portfolio Analysis", "User Auth"],
            status: "In Progress"
        },
        {
            id: 5,
            title: "Buber Breakfast",
            description: "A breakfast delivery application with order management and user authentication system.",
            category: "Web App",
            technologies: ["ASP.NET Core", "Clean Architecture", "SQL Server"],
            github: "https://github.com/Lanyamhamad/BuberBreakfast",
            features: ["Clean Architecture", "CRUD Operations", "RESTful API Design"],
            status: "In Progress"
        },
        {
            id: 6,
            title: "Task Management Application",
            description: "A simple to-do application with task categorization, priority management, and deadline tracking.",
            category: "Mobile App",
            technologies: ["Dart", "Flutter", "Firebase Firestore"],
            github: "https://github.com/Lanyamhamad/task_management",
            features: ["Task CRUD", "Priority System", "Deadline Tracking"],
            status: "Prototype"
        },
        {
            id: 7,
            title: "Game Application",
            description: "An interactive gaming platform with user profiles, leaderboards, and game state management.",
            category: "Web App",
            technologies: ["ASP.NET Core", "SQLite", "Entity Framework", "JavaScript"],
            github: "https://github.com/Lanyamhamad",
            features: ["Real-time Updates", "User Authentication", "Leaderboards"],
            status: "Prototype"
        },
        {
            id: 8,
            title: "Portfolio Website",
            description: "A personal portfolio website showcasing projects, skills, and experience with a modern design and responsive layout.",
            category: "Web App",
            technologies: ["ASP.NET Core", "PostgreSQL", "Entity Framework", "React", "Tailwind CSS"],
            github: "https://github.com/Lanyamhamad",
            features: ["Real-time Updates", "User Authentication", "Admin Panel", "Responsive Design", "Contact Form", "Project showcase", "Certification Section"],
            status: "Completed"
        },
        {
            id: 9,
            title: "POS Desktop Application",
            description: "A desktop application for managing point-of-sale operations with inventory tracking and sales reporting.",
            category: "Desktop App",
            technologies: ["C#", "WPF", "postgreSQL", "Entity Framework"],
            github: "https://github.com/Lanyamhamad/POS-Desktop-Application",
            features: ["Inventory Management", "Sales Reporting", "User Authentication", "Real-time Updates"],
            status: "In Progress"
        }

    ],

    experience: [
        {
            id: 0,
            title: "Software Developer · QA/QC Analyst",
            company: "DreamIT",
            period: "2025 – Present",
            type: "Full-time",
            location: "Sulaymaniyah, Iraq",
            description: "Responsibilities evolved from application development to software testing, quality control, and ERP system analysis.",
            detailedDescription: [
                "Windows Desktop Application: Contributed to feature development, application functionality, and debugging.",
                "Website Development: Developed a website from the ground up, verifying structure and functionality.",
                "Software Testing & Quality Control: Executed ERP quality checklists, tested business workflows, and documented defects.",
                "ERP System Analysis: Created execution reports, analyzed module relationships, and documented cross-module dependencies."
            ]
        },
        {
            id: 1,
            title: "DOTNET Programmer",
            company: "Sharp Soft",
            period: "Sep 2024 – 18th Oct 2025",
            type: "Full-time",
            description: "Developed and maintained web applications using ASP.NET and Entity Framework. Collaborated with cross-functional teams to deliver high-quality software solutions.",
            detailedDescription: [
                "Contributed to the development and maintenance of a large ERP system using ASP.NET MVC.",
                "Developed and maintained backend APIs and business logic using C# and ASP.NET technologies.",
                "Worked closely with the database team to design and optimize SQL Server databases. and uses Stored Procedures to improve performance and  enterprise-level application structures.",
                "Participated in code reviews and provided constructive feedback to team members.",
                "Implemented Repository and Service Layer patterns following Clean Architecture principles.",
                "Gained experience working in professional team environments and real-world software systems.",
                "Working on realistic projects and communicating with clients.",
                "Collaborating with team members and learning to work in a professional software development environment.",
                "Gained practical experience in software development and improved coding skills.",
                "Worked on real-world projects and gained practical experience in software development."
            ]
        },
        {
            id: 2,
            title: "Backend Intern",
            company: "Kubak Tech",
            period: "July 2024 – 15th Aug 2024",
            type: "Internship",
            description: "learned and applied best practicesin the development and maintenance of backend systems using C# and ASP.NET CORE",
            detailedDescription: [
                "Internship as a backend programmer in ASP.NET Core in Sulaymaniyah",
                "Assisted in the development and maintenance of backend systems using C# and ASP.NET.",
                "Developed and maintained web APIs using ASP.NET Core, focusing on RESTful services and implementing CRUD operations.",
                "Collaborated with senior developers to learn best practices and improve coding skills.",
                "Participated in team meetings and contributed to project discussions, and leaning how to collaborate effectively in a professional software development environment.",
                "Learning to integrate databases with applications through Entity Framework Core.",
                "Implemented authentication and authorization systems using ASP.NET Core Identity and JWT for secure user management.",
                "Created 4 projects from beginner to intermediate level, including a To Do application, Buber Breakfast, a game application, and FinShark (a financial application).",
                "Passionate about clean code and performance optimization.",
                "Saw on real-world projects and gained practical experience in software development."
            ]
        }
    ],

    certifications: [
        {
            id: 1,
            title: "Advanced ASP.NET Core MVC",
            description: "Comprehensive training on building enterprise applications with ASP.NET Core MVC, covering security, performance, and architecture.",
            year: "2025",
            image: "/certification-placeholder.jpg" // Replace with your actual image path
        },
        {
            id: 2,
            title: "Clean Architecture in C#",
            description: "Deep dive into Domain-Driven Design (DDD) and Clean Architecture principles for building scalable and maintainable .NET backends.",
            year: "2024",
            image: "/certification-placeholder.jpg"
        }
    ]
};
